declare var google: any

import { Injectable, NgZone } from '@angular/core'
import { ReplaySubject, Subject } from 'rxjs'
import window from '../libs/window'
import { take } from 'rxjs/operators'
import { accounts } from 'google-one-tap'
import { AppConfig } from '../config'

@Injectable()
export class GoogleSignInService {
  _onAuthorized$: Subject<any> = new Subject()
  gAccounts: accounts

  private completionPromise: Promise<void>
  private completionResolve: () => void

  get onAuthorized$() {
    return this._onAuthorized$.asObservable()
  }

  constructor(
    private ngZone: NgZone
  ) {
    this.completionPromise = new Promise((resolve) => {
      this.completionResolve = resolve
    })
    this.loadScript()
  }

  async attachButton(elm: HTMLElement) {
    await this.completionPromise
    this.gAccounts.id.renderButton(elm, {
      size: 'large',
      width: elm.clientWidth,
      theme: 'outline',
      type: 'standard',
    })
  }

  private createApi = () => {
    this.gAccounts = google.accounts

    this.gAccounts.id.initialize({
      client_id: AppConfig.googleOAuthClientId,
      ux_mode: 'popup',
      cancel_on_tap_outside: true,
      callback: ({ credential }) => {
        this.ngZone.run(() => {
          this._onAuthorized$.next(credential)
        })
      },
    })

    this.completionResolve()
  }

  private loadScript() {
    let exists = document.getElementById('google-auth-script-tag')
    if (!exists) {
      let tag = document.createElement('script')
      tag.src = 'https://accounts.google.com/gsi/client'
      tag.setAttribute('id', 'google-auth-script-tag')
      let firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
      tag.onload = this.createApi
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/google-sign-in.ts